import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatEducationalFieldLabel } from './educational-content-view-model';

@Pipe({
  name: 'eduFieldLabel',
  standalone: true,
  pure: false,
})
export class EducationalFieldLabelPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(fieldKey: string | null | undefined): string {
    if (fieldKey == null || fieldKey === '') return '';
    return formatEducationalFieldLabel(fieldKey, k => this.translate.instant(k));
  }
}
